export default class ClubFeeCategory {
    static fromData(data) {
        if (!data) {
            return;
        }

        const clubFeeCategory = new ClubFeeCategory();
        clubFeeCategory.id = data.id;
        clubFeeCategory.name = data.name;
        clubFeeCategory.paymentApproach = data.paymentApproach;

        Object.seal(clubFeeCategory);
        return clubFeeCategory;
    }
}
